import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: 'https://lws-server-for-assignmentss.herokuapp.com/',
});

export default axiosInstance;
